import React from 'react'
import './disclaimer.scss'

export const DisclaimerContainer = () => {
  return (
    <div className='container disclaimer-container'>
      <h2>Disclaimer</h2>
      <p>
        This communication is issued by Credibila Markets (&ldquo;Credibila&rdquo;), which is
        licensed and regulated by the Financial Services Commission, Mauritius, as an Investment
        Dealer (Full Service Dealer, excluding Underwriting).
      </p>
      <br />
      <p>
        This material regarding the Credibila Creative Concepts is for information purposes only and
        does not constitute investment advice, a recommendation, or an offer or solicitation in any
        jurisdiction where such offer or solicitation would be unlawful.
      </p>
      <br />
      <p>
        Access to any investment opportunity is subject to availability, investor eligibility,
        applicable jurisdictional restrictions, successful completion of onboarding/KYC requirements
        and the relevant transaction documentation. Minimum participation, where stated, is also
        subject to the applicable terms and conditions. Investments in private/unlisted securities
        involve substantial risk, may be highly illiquid, may have limited or no secondary market,
        and investors may lose some or all of their invested capital.
      </p>
      <br />
      <p>
        There is no guarantee of returns, liquidity, exit or future valuation. Any historical
        financial or operational information relating to any investment opportunity, including
        revenue, revenue growth, membership or geographic statistics, is provided for informational
        purposes only. Past or historical company performance is not indicative of future
        performance or investment returns. Unless expressly stated otherwise, Credibila is not
        affiliated with, sponsored by, endorsed by or acting on behalf of any investee entity or
        their underlying related parties, and should not be interpreted as an endorsement of
        Credibila or the investment opportunity. Prospective investors should carefully review the
        applicable transaction, offering and risk documentation and obtain independent legal, tax
        and financial advice before making an investment decision.
      </p>
      <br />
      <p>
        Any historical financial, operational or market information, including revenue, growth,
        membership, geographic presence, financial performance or share price data, is provided for
        informational purposes only and is based on publicly available information. No
        representation or warranty is made as to its accuracy or completeness.
      </p>
      <br />
      <p>
        Unless expressly stated otherwise, Credibila is not affiliated with, sponsored by, endorsed
        by or acting on behalf of prospective investment opportunities entities, and references to
        prospective investment opportunities entities should not be interpreted as an endorsement of
        Credibila or the investment opportunities.
      </p>
      <br />
      <p>
        This material is for informational purposes only and does not constitute an offer,
        solicitation, recommendation or investment advice to buy or sell any securities. Prospective
        investors should conduct their own due diligence and refer to the listed entity&apos;s
        official regulatory and stock exchange disclosures before making any investment decision.
      </p>
    </div>
  )
}
